import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import React, { Component } from "react";
import { fetchServiceRequestByItemId } from "../../store/actions/serviceRequests";
import { selectServiceRequests } from "../../store/selectors/serviceRequests";
import ServiceRequestsTable from "../../components/ServiceRequestsTable/ServiceRequestsTable_legacy";
import { setSearch, clearSearch } from "../../store/actions/search";
import { selectAuthenticatedUser } from "../../store/selectors/auth";
import Loader from "../../components/Loader";
import { selectLoader } from "../../store/selectors/loader";
import { PATHS } from "../../common/constants";
import { fetchCatalogItemServiceRequestCSVExportDownloadList } from "../../store/actions/csvExport";

class ItemServiceRequest extends Component {
  state = {
    searchString: "",
  };
  componentDidMount() {
    const { item, fetchServiceRequestByItemId, user } = this.props;
    fetchServiceRequestByItemId(
      item.id,
      user.id,
      user.roles[0].role.name,
      1,
      ""
    );

    this.props.clearSearch();
  }
  loadMoreServiceRequest = async () => {
    const { fetchServiceRequestByItemId, paginationCount, item, user } =
      this.props;
    fetchServiceRequestByItemId(
      item.id,
      user.id,
      user.roles[0].role.name,
      paginationCount + 1,
      this.state.searchString
    );
  };
  search = async (text) => {
    this.setState({ searchString: text });
    // console.log("Text", text);
    const { user, fetchServiceRequestByItemId, item } = this.props;

    fetchServiceRequestByItemId(
      item.id,
      user.id,
      user.roles[0].role.name,
      1,
      text,
      true
    );
  };

  downloadCSV() {
    const { fetchCatalogItemServiceRequestCSVExportDownloadList, user, item } =
      this.props;
    fetchCatalogItemServiceRequestCSVExportDownloadList(
      item.id,
      user.id,
      user.roles[0].role.name,
      this.state.searchString
    );
  }

  render() {
    const { property, serviceRequests, setSearch, item, loader } = this.props;
    return loader ? (
      <Loader />
    ) : (
      <ServiceRequestsTable
        download={() => this.downloadCSV()}
        serviceRequests={serviceRequests}
        // onSearch={e => setSearch({ serviceRequests: e.target.value.trim() })}
        onSearch={(e) => this.search(e.target.value.trim())}
        itemView={true}
        loadServiceRequest={this.loadMoreServiceRequest}
        from="Item"
        navigateTo={PATHS.ITEMS_VIEW.replace(":id", item.id)}
        // serviceRequest={{ property_id: property.id,propertyId:property.id }}
      />
    );
  }
}

const mapStateToProps = (state) => {
  return {
    paginationCount: state.paginationCount.count,
    pageCount: state.serviceRequestStatusPageCount.pageCount,
    serviceRequests: selectServiceRequests(state),
    user: selectAuthenticatedUser(state),
    loader: selectLoader(state),
  };
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      fetchServiceRequestByItemId: fetchServiceRequestByItemId,
      setSearch,
      clearSearch,
      fetchCatalogItemServiceRequestCSVExportDownloadList:
        fetchCatalogItemServiceRequestCSVExportDownloadList,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(ItemServiceRequest);
